<template>
  <div>
    <router-view></router-view>
    <PageHeaderLayout v-show="this.$route.matched.length==2">
      <div class="main-page-content">
        <!-- 页面标题区域 -->
        <div class="page-title-section">
          <div class="title-content">
            <h1 class="page-title">
              <i class="el-icon-s-order"></i>
              订单项目管理
            </h1>
            <p class="page-subtitle">管理订单详细项目信息，包含材料、文件和后处理工艺</p>
          </div>
        </div>

        <!-- 操作面板 -->
        <div class="action-card">
          <div class="action-buttons">
            <el-tooltip effect="dark" content="添加订单项" placement="top" v-if="userPermissions.indexOf('craft_add') != -1 && buttonType=='icon'">
              <el-button type="primary" size="mini" icon="el-icon-plus" @click="addButton()"></el-button>
            </el-tooltip>
            <el-button type="primary" size="mini" icon="el-icon-plus" v-if="userPermissions.indexOf('craft_add') != -1 && buttonType=='text'" @click="addButton()">添加订单项</el-button>
            
            <el-tooltip effect="dark" content="批量操作" placement="top" v-if="buttonType=='icon'">
              <el-button type="warning" size="mini" icon="el-icon-s-operation" @click="batchOperation()"></el-button>
            </el-tooltip>
            <el-button type="warning" size="mini" icon="el-icon-s-operation" v-if="buttonType=='text'" @click="batchOperation()">批量操作</el-button>
            
            <el-tooltip effect="dark" content="导出数据" placement="top" v-if="buttonType=='icon'">
              <el-button type="success" size="mini" icon="el-icon-download" @click="exportData()"></el-button>
            </el-tooltip>
            <el-button type="success" size="mini" icon="el-icon-download" v-if="buttonType=='text'" @click="exportData()">导出数据</el-button>
          </div>
        </div>

        <!-- 搜索筛选卡片 -->
        <div class="search-card">
          <div class="search-header">
            <i class="el-icon-search"></i>
            <span>筛选条件</span>
          </div>
          <div class="search-content">
            <el-form size="mini" :inline="true" :model="searchCondition" class="search-form">
              <el-form-item label="材料名称">
                <el-input v-model="searchCondition.material_name" placeholder="请输入材料名称" clearable prefix-icon="el-icon-goods">
                </el-input>
              </el-form-item>
              <el-form-item label="颜色">
                <el-input v-model="searchCondition.color_name" placeholder="请输入颜色" clearable prefix-icon="el-icon-brush">
                </el-input>
              </el-form-item>
              <el-form-item label="数量">
                <el-input v-model="searchCondition.quantity" placeholder="请输入数量" clearable prefix-icon="el-icon-s-grid">
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="mini" icon="el-icon-search" @click="getList">查询</el-button>
                <el-button size="mini" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <!-- 表格卡片 -->
        <div class="table-card">
          <div class="order-overview-card" v-if="dataList && dataList.length">
            <div class="overview-title">
              <i class="el-icon-data-analysis"></i>
              <span>订单项目汇总（订单号：{{ $route.params.id }}）</span>
            </div>
            <div class="overview-content">
              <el-tag type="info" size="mini">项目数：{{ dataList.length }}</el-tag>
              <el-tag type="warning" size="mini">数量合计：{{ getTotalQuantity(dataList) }}</el-tag>
              <el-tag type="danger" size="mini">金额合计：{{ formatMoney(getTotalSubPrice(dataList)) }}</el-tag>
              <el-tag type="success" size="mini">后处理总价：{{ formatMoney(getTotalFollowCraftPrice(dataList)) }}</el-tag>
              <el-tag type="primary" size="mini">最长总工期：{{ formatDays(getMaxTotalDuration(dataList)) }}</el-tag>
              <el-tag type="success" size="mini">后处理项合计：{{ getTotalFollowCraftCount(dataList) }}</el-tag>
            </div>
          </div>

          <div class="table-header">
            <div class="header-left">
              <h3 class="table-title">
                <i class="el-icon-menu"></i>
                订单项目列表
              </h3>
            </div>
            <div class="header-right">
              <span class="data-count">共 {{pagingData.total}} 条数据</span>
            </div>
          </div>
          
          <ApeTable ref="apeTable" :data="dataList" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row>
            <el-table-column width="60" label="序号" align="center">
              <template slot-scope="scope">
                <span class="sequence-number">{{offset+scope.$index+1}}</span>
              </template>
            </el-table-column>

            <el-table-column label="订单项目基础信息" min-width="230">
              <template slot-scope="scope">
                <div class="order-item-basic">
                  <div class="info-row">
                    <i class="el-icon-document"></i>
                    <span class="info-label">订单号：</span>
                    <span class="info-value">{{ scope.row.order_no || '-' }}</span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-key"></i>
                    <span class="info-label">项目ID：</span>
                    <span class="info-value">{{ scope.row.id || '-' }}</span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-s-order"></i>
                    <span class="info-label">材料ID：</span>
                    <span class="info-value">{{ scope.row.material_id || '-' }}</span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-document-copy"></i>
                    <span class="info-label">文件ID：</span>
                    <span class="info-value">{{ scope.row.file_id || '-' }}</span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-bank-card"></i>
                    <span class="info-label">币种：</span>
                    <span class="info-value">{{ scope.row.currency || 'USD' }}</span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-time"></i>
                    <span class="info-label">创建时间：</span>
                    <span class="info-value">{{ formatDateTime(scope.row.created_at) }}</span>
                  </div>
                </div>
              </template>
            </el-table-column>
            
            <el-table-column label="材料信息汇总" min-width="300">
              <template slot-scope="scope">
                <div class="material-summary">
                  <div class="summary-header">
                    <div class="material-title">
                      <i class="el-icon-goods"></i>
                      <span class="material-name">{{scope.row.Material.material_name}}</span>
                      <el-tag :type="scope.row.Material.material_recommend=='1'?'success':'info'" size="mini">
                        {{scope.row.Material.material_recommend=='1'?'推荐':'普通'}}
                      </el-tag>
                    </div>
                    <div class="material-image">
                      <img :src="publicAssetUrl(scope.row.Material.material_pic)" alt="材料图片">
                    </div>
                  </div>
                  
                  <div class="summary-content">
                    <div class="summary-row">
                      <i class="el-icon-cpu"></i>
                      <span class="summary-label">工艺类型：</span>
                      <el-tag :type="scope.row.Material.material_type=='2'?'success':'warning'" size="mini">
                        {{scope.row.Material.material_type=='2'?'SLA':'其他'}}
                      </el-tag>
                    </div>
                    <div class="summary-row">
                      <i class="el-icon-s-data"></i>
                      <span class="summary-label">密度：</span>
                      <el-tag type="info" size="mini">{{scope.row.Material.material_density}}g/cm³</el-tag>
                    </div>
                    <div class="summary-row">
                      <i class="el-icon-s-operation"></i>
                      <span class="summary-label">精度：</span>
                      <el-tag type="primary" size="mini">{{scope.row.Material.tolerance_precision}}</el-tag>
                    </div>
                    <div class="summary-row">
                      <i class="el-icon-s-grid"></i>
                      <span class="summary-label">最大尺寸：</span>
                      <span class="summary-value">{{scope.row.Material.material_max_size}}</span>
                    </div>
                    <div class="summary-row">
                      <i class="el-icon-money"></i>
                      <span class="summary-label">单价：</span>
                      <span class="summary-value price">¥{{scope.row.Material.material_unit_price}}</span>
                    </div>
                    <div class="summary-row">
                      <i class="el-icon-s-finance"></i>
                      <span class="summary-label">抛光价格：</span>
                      <span class="summary-value price">¥{{scope.row.Material.material_polishing_price}}</span>
                    </div>
                    <div class="summary-row">
                      <i class="el-icon-edit-outline"></i>
                      <span class="summary-label">材料描述：</span>
                      <el-button type="text" size="mini" @click="showMaterialDesc(scope.row.Material)">
                        <i class="el-icon-view"></i>
                        查看详情
                      </el-button>
                    </div>
                  </div>
                  
                  <div class="material-tags">
                    <div class="tags-title">材料标签：</div>
                    <div class="tags-container">
                      <el-tag v-for="tag in ((scope.row.Material.material_label || '').split(',').map(t => t.trim()).filter(Boolean))" :key="tag" size="mini" type="info" style="margin: 2px;">
                        {{tag}}
                      </el-tag>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="文件信息汇总" min-width="260">
              <template slot-scope="scope">
                <div class="file-summary">
                  <div class="summary-header">
                    <div class="file-title">
                      <i class="el-icon-document"></i>
                      <span class="file-name">{{scope.row.File.file_name}}</span>
                      <el-tag size="mini" type="primary">{{scope.row.File.file_format.toUpperCase()}}</el-tag>
                    </div>
                  </div>
                  
                  <div class="summary-content">
                    <div class="summary-row">
                      <i class="el-icon-pie-chart"></i>
                      <span class="summary-label">文件大小：</span>
                      <el-tag type="warning" size="mini">{{(scope.row.File.file_size/1024/1024).toFixed(2)}}MB</el-tag>
                    </div>
                    <div class="summary-row">
                      <i class="el-icon-s-data"></i>
                      <span class="summary-label">体积：</span>
                      <el-tag type="success" size="mini">{{scope.row.File.file_volume.toFixed(2)}}cm³</el-tag>
                    </div>
                    <div class="summary-row">
                      <i class="el-icon-s-grid"></i>
                      <span class="summary-label">尺寸：</span>
                      <span class="summary-value">{{scope.row.File.file_length}}×{{scope.row.File.file_width}}×{{scope.row.File.file_high}}mm</span>
                    </div>
                    <div class="summary-row">
                      <i class="el-icon-s-data"></i>
                      <span class="summary-label">体积面积：</span>
                      <el-tag type="info" size="mini">{{scope.row.File.file_volumearea.toFixed(2)}}cm²</el-tag>
                    </div>
                    <div class="summary-row">
                      <i class="el-icon-s-data"></i>
                      <span class="summary-label">重量：</span>
                      <el-tag type="info" size="mini">{{formatWeight(scope.row.File.file_weight)}}</el-tag>
                    </div>
                    <div class="summary-row">
                      <i class="el-icon-time"></i>
                      <span class="summary-label">上传时间：</span>
                      <span class="summary-value">{{formatDateTime(scope.row.File.upload_at)}}</span>
                    </div>
                    <div class="summary-row">
                      <i class="el-icon-link"></i>
                      <span class="summary-label">下载：</span>
                      <el-link type="primary" class="file-link" @click.native.prevent="openDownloadDialog(scope.row)">
                        <i class="el-icon-download"></i>
                        下载文件
                      </el-link>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="后处理信息汇总" min-width="240">
              <template slot-scope="scope">
                <div class="post-processing-summary">
                  <div class="summary-header">
                    <div class="craft-title">
                      <i class="el-icon-cpu"></i>
                      <span class="craft-name">后处理信息</span>
                      <el-tag :type="getFollowCraftDetailList(scope.row).length > 0 ? 'success' : 'info'" size="mini">
                        {{ getFollowCraftDetailList(scope.row).length }}项
                      </el-tag>
                    </div>
                  </div>
                  
                  <div class="summary-content">
                    <div class="summary-row">
                      <i class="el-icon-money"></i>
                      <span class="summary-label">后处理总价：</span>
                      <span class="summary-value price">{{formatMoney(scope.row.follow_craft_price)}}</span>
                    </div>
                    <div class="summary-row">
                      <i class="el-icon-timer"></i>
                      <span class="summary-label">后处理工期：</span>
                      <el-tag type="info" size="mini">{{formatDays(scope.row.follow_craft_duration)}}</el-tag>
                    </div>
                    <div class="summary-row" v-if="getFollowCraftDetailList(scope.row).length > 0">
                      <i class="el-icon-s-operation"></i>
                      <span class="summary-label">后处理项数：</span>
                      <el-tag type="success" size="mini">{{getFollowCraftDetailList(scope.row).length}}项</el-tag>
                    </div>
                    <div class="summary-row" v-else>
                      <i class="el-icon-s-operation"></i>
                      <span class="summary-label">后处理项数：</span>
                      <el-tag type="info" size="mini">未选择</el-tag>
                    </div>
                    <div class="summary-row" v-if="getFollowCraftDetailList(scope.row).length > 0">
                      <i class="el-icon-s-data"></i>
                      <span class="summary-label">后处理内容：</span>
                      <div class="craft-stats">
                        <el-tag v-for="(detail, index) in getFollowCraftDetailList(scope.row).slice(0, 3)" :key="index" type="primary" size="mini" style="margin: 2px;">
                          {{ getFollowCraftName(detail) }}
                        </el-tag>
                        <el-tag v-if="getFollowCraftDetailList(scope.row).length > 3" type="warning" size="mini" style="margin: 2px;">
                          +{{getFollowCraftDetailList(scope.row).length - 3}}项
                        </el-tag>
                      </div>
                    </div>
                    <div
                      class="summary-row follow-craft-detail-row"
                      v-for="(detail, detailIndex) in getFollowCraftDetailList(scope.row).slice(0, 3)"
                      :key="`detail-${scope.row.id}-${detailIndex}`"
                    >
                      <i class="el-icon-collection-tag"></i>
                      <span class="summary-label">项目{{ detailIndex + 1 }}：</span>
                      <span class="summary-value">
                        {{ getFollowCraftName(detail) }} | 数量 {{ detail.quantity || 0 }} |
                        单价 {{ formatMoney(detail.follow_craft_price || detail.price || 0) }} |
                        工期 {{ formatDays(detail.duration || detail.elapsed_days || 0) }}
                      </span>
                    </div>
                    <div class="summary-row" v-if="getFollowCraftDetailList(scope.row).length > 0">
                      <i class="el-icon-s-operation"></i>
                      <span class="summary-label">后处理详情：</span>
                      <el-button type="text" size="mini" @click="viewCraftDetail(scope.row)">
                        <i class="el-icon-view"></i>
                        查看详情
                      </el-button>
                      <el-button type="text" size="mini" @click="goCraftDetailPage(scope.row)">
                        <i class="el-icon-right"></i>
                        进入明细页
                      </el-button>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="附件信息汇总" min-width="220">
              <template slot-scope="scope">
                <div class="attachment-summary">
                  <div class="summary-header">
                    <div class="attachment-title">
                      <i class="el-icon-paperclip"></i>
                      <span class="attachment-name">附件信息</span>
                      <el-tag :type="mergedAttachmentCount(scope.row) > 0 ? 'success' : 'info'" size="mini">
                        {{ mergedAttachmentCount(scope.row) }}个
                      </el-tag>
                    </div>
                  </div>
                  
                  <div class="summary-content">
                    <div class="summary-row">
                      <i class="el-icon-document"></i>
                      <span class="summary-label">主文件：</span>
                      <el-tag type="primary" size="mini">{{scope.row.File.file_name}}</el-tag>
                    </div>
                    <div class="summary-row" v-if="mergedAttachmentCount(scope.row) > 0">
                      <i class="el-icon-files"></i>
                      <span class="summary-label">附件统计：</span>
                      <el-tag type="success" size="mini">{{ mergedAttachmentCount(scope.row) }}个</el-tag>
                    </div>
                    <div class="summary-row" v-else>
                      <i class="el-icon-files"></i>
                      <span class="summary-label">附件统计：</span>
                      <el-tag type="info" size="mini">无附件</el-tag>
                    </div>
                    <div class="summary-row" v-if="mergedAttachmentCount(scope.row) > 0">
                      <i class="el-icon-s-data"></i>
                      <span class="summary-label">附件预览：</span>
                      <div class="attachment-list">
                        <el-tag v-for="(fileId, index) in mergedAttachmentIds(scope.row).slice(0, 3)" :key="fileId" type="info" size="mini" style="margin: 2px;">
                          附件{{index + 1}}
                        </el-tag>
                        <el-tag v-if="mergedAttachmentIds(scope.row).length > 3" type="warning" size="mini" style="margin: 2px;">
                          +{{mergedAttachmentIds(scope.row).length - 3}}个
                        </el-tag>
                      </div>
                    </div>
                    <div class="summary-row">
                      <i class="el-icon-link"></i>
                      <span class="summary-label">文件下载：</span>
                      <el-link type="primary" class="file-link" @click.native.prevent="openDownloadDialog(scope.row)">
                        <i class="el-icon-download"></i>
                        主文件+附件
                      </el-link>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="费用与工期汇总" min-width="220" align="center">
              <template slot-scope="scope">
                <div class="total-price-display">
                  <div class="price-breakdown">
                    <div class="price-item">
                      <span class="price-label">工艺类型：</span>
                      <el-tag :type="scope.row.craft_type=='1'?'success':'warning'" size="mini">
                        {{scope.row.craft_type=='1'?'SLA':'其他'}}
                      </el-tag>
                    </div>
                    <div class="price-item">
                      <span class="price-label">基础价格：</span>
                      <span class="price-value">{{formatMoney(scope.row.base_price)}}</span>
                    </div>
                    <div class="price-item" v-if="scope.row.follow_craft_price > 0">
                      <span class="price-label">后处理价格：</span>
                      <span class="price-value">{{formatMoney(scope.row.follow_craft_price)}}</span>
                    </div>
                    <div class="duration-item">
                      <span class="duration-label">基础工期：</span>
                      <el-tag type="primary" size="mini">{{formatDays(scope.row.duration)}}</el-tag>
                    </div>
                    <div class="duration-item" v-if="scope.row.follow_craft_duration > 0">
                      <span class="duration-label">后处理工期：</span>
                      <el-tag type="warning" size="mini">{{formatDays(scope.row.follow_craft_duration)}}</el-tag>
                    </div>
                    <div class="price-total">
                      <el-tag type="danger" size="large">
                        <i class="el-icon-s-finance"></i>
                        总价: {{formatMoney(scope.row.sub_total_price)}}
                      </el-tag>
                    </div>
                    <div class="duration-total">
                      <el-tag type="success" size="large">
                        <i class="el-icon-timer"></i>
                        总工期: {{formatDays(scope.row.total_duration)}}
                      </el-tag>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="备注" min-width="120" align="center">
              <template slot-scope="scope">
                <div class="remark-display">
                  <el-tag v-if="scope.row.mark" type="info" size="medium">
                    <i class="el-icon-edit-outline"></i>
                    {{scope.row.mark}}
                  </el-tag>
                  <span v-else class="no-remark">无备注</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column v-if="buttonType=='icon'" width="200" label="操作" align="center" fixed="right">
              <template slot-scope="scope">
                <div class="action-buttons">
                  <el-tooltip effect="dark" content="编辑" placement="top" v-if="userPermissions.indexOf('craft_modify') != -1">
                    <el-button size="mini" icon="el-icon-edit" circle type="primary" @click="editButton(scope.row.id)"></el-button>
                  </el-tooltip>
                  <el-tooltip effect="dark" content="查看后处理详情" placement="top">
                    <el-button size="mini" icon="el-icon-view" circle type="info" @click="viewCraftDetail(scope.row)"></el-button>
                  </el-tooltip>
                  <el-tooltip effect="dark" content="复制" placement="top" v-if="userPermissions.indexOf('craft_add') != -1">
                    <el-button size="mini" icon="el-icon-copy-document" circle type="warning" @click="copyButton(scope.row)"></el-button>
                  </el-tooltip>
                  <el-tooltip effect="dark" content="删除" placement="top">
                    <span>
                      <el-popover
                        v-if="userPermissions.indexOf('craft_delete') != -1"
                        placement="top"
                        width="150"
                        v-model="scope.row.visible">
                        <p>确定要删除记录吗？</p>
                        <div style="text-align: right; margin: 0;">
                          <el-button type="text" size="mini" @click="scope.row.visible=false">取消</el-button>
                          <el-button type="danger" size="mini" @click="deleteButton(scope.row.id)">确定</el-button>
                        </div>
                        <el-button slot="reference" type="danger" size="mini" icon="el-icon-delete" circle></el-button>
                      </el-popover>
                    </span>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </ApeTable>
        </div>
      </div>
    </PageHeaderLayout>

    <!-- 添加/编辑抽屉 -->
    <ApeDrawer :drawerData="drawerData" @drawerClose="drawerClose" @drawerConfirm="drawerConfirm">
      <template slot="ape-drawer">
        <el-form :model="formData" :rules="rules" ref="dataForm" label-position="right" label-width="96px">
          <el-row>
            <el-col :span="22">
              <el-form-item label="材料名称" prop="material_name">
                <el-input v-model="formData.material_name" prefix-icon="el-icon-goods"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="数量" prop="quantity">
                <el-input-number v-model="formData.quantity" :min="1" :max="999999" prefix-icon="el-icon-s-grid"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="颜色" prop="color_name">
                <el-input v-model="formData.color_name" prefix-icon="el-icon-brush"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="备注" prop="remark">
                <el-input type="textarea" v-model="formData.remark" placeholder="请输入备注信息"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>     
      </template>
    </ApeDrawer>

    <el-dialog
      title="订单工艺与后处理完整详情"
      :visible.sync="craftDetailDialogVisible"
      width="980px"
      append-to-body
      class="order-item-detail-dialog"
    >
      <div v-if="craftDetailDialogRow" class="craft-detail-content">
        <div class="detail-block">
          <div class="block-title"><i class="el-icon-s-order"></i> 订单项目信息</div>
          <el-row :gutter="12">
            <el-col :span="8"><div class="kv-line"><span>订单号：</span>{{ craftDetailDialogRow.order_no || '-' }}</div></el-col>
            <el-col :span="8"><div class="kv-line"><span>项目ID：</span>{{ craftDetailDialogRow.id || '-' }}</div></el-col>
            <el-col :span="8"><div class="kv-line"><span>创建时间：</span>{{ formatDateTime(craftDetailDialogRow.created_at) }}</div></el-col>
          </el-row>
          <el-row :gutter="12">
            <el-col :span="8"><div class="kv-line"><span>数量：</span>{{ craftDetailDialogRow.quantity || 0 }}</div></el-col>
            <el-col :span="8"><div class="kv-line"><span>颜色：</span>{{ craftDetailDialogRow.color_name || '-' }}</div></el-col>
            <el-col :span="8"><div class="kv-line"><span>备注：</span>{{ craftDetailDialogRow.mark || '-' }}</div></el-col>
          </el-row>
        </div>

        <div class="detail-block">
          <div class="block-title"><i class="el-icon-cpu"></i> 订单工艺信息（基础工艺）</div>
          <el-row :gutter="12">
            <el-col :span="8"><div class="kv-line"><span>工艺类型：</span>{{ craftDetailDialogRow.craft_type == '1' ? 'SLA' : '其他' }}</div></el-col>
            <el-col :span="8"><div class="kv-line"><span>基础价格：</span>{{ formatMoney(craftDetailDialogRow.base_price) }}</div></el-col>
            <el-col :span="8"><div class="kv-line"><span>基础工期：</span>{{ formatDays(craftDetailDialogRow.duration) }}</div></el-col>
          </el-row>
          <el-row :gutter="12">
            <el-col :span="8"><div class="kv-line"><span>后处理总价：</span>{{ formatMoney(craftDetailDialogRow.follow_craft_price) }}</div></el-col>
            <el-col :span="8"><div class="kv-line"><span>后处理工期：</span>{{ formatDays(craftDetailDialogRow.follow_craft_duration) }}</div></el-col>
            <el-col :span="8"><div class="kv-line"><span>总价/总工期：</span>{{ formatMoney(craftDetailDialogRow.sub_total_price) }} / {{ formatDays(craftDetailDialogRow.total_duration) }}</div></el-col>
          </el-row>
        </div>

        <div class="detail-block">
          <div class="block-title"><i class="el-icon-s-operation"></i> 后处理工艺明细（全部）</div>
          <el-table :data="getFollowCraftDetailList(craftDetailDialogRow)" border size="mini" max-height="320">
            <el-table-column type="index" width="56" label="#" />
            <el-table-column label="后处理名称" min-width="140">
              <template slot-scope="scope">
                {{ getFollowCraftName(scope.row) }}
              </template>
            </el-table-column>
            <el-table-column prop="follow_craft_id" label="后处理ID" min-width="120" />
            <el-table-column label="数量" width="76">
              <template slot-scope="scope">{{ scope.row.quantity || 0 }}</template>
            </el-table-column>
            <el-table-column label="单价" min-width="110">
              <template slot-scope="scope">{{ formatMoney(scope.row.follow_craft_price || scope.row.price || 0) }}</template>
            </el-table-column>
            <el-table-column label="工期" min-width="90">
              <template slot-scope="scope">{{ formatDays(scope.row.duration || scope.row.elapsed_days || 0) }}</template>
            </el-table-column>
            <el-table-column label="说明" min-width="260">
              <template slot-scope="scope">
                <span>{{ (scope.row.FollowCraft && scope.row.FollowCraft.follow_craft_desc) || scope.row.info || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="附件下载" min-width="220">
              <template slot-scope="scope">
                <div class="attachment-links">
                  <template v-if="getFollowCraftAttachmentFiles(craftDetailDialogRow, scope.row).length">
                    <el-link
                      v-for="(file, idx) in getFollowCraftAttachmentFiles(craftDetailDialogRow, scope.row)"
                      :key="file.id || idx"
                      type="primary"
                      :underline="false"
                      style="margin-right: 8px;"
                      @click="openHref(file.file_path)"
                    >
                      <i class="el-icon-download"></i>
                      {{ file.file_name || ('附件' + (idx + 1)) }}
                    </el-link>
                  </template>
                  <span v-else class="empty-attachment">无可下载附件</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="craftDetailDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>

    <el-dialog title="下载文件" :visible.sync="downloadDialogVisible" width="520px" append-to-body>
      <div v-if="downloadDialogRow && downloadDialogRow.File">
        <p><strong>主文件：</strong>{{ downloadDialogRow.File.file_name }}</p>
        <el-button type="primary" size="small" icon="el-icon-download" @click="openHref(downloadDialogRow.File.file_path)">下载主文件</el-button>
        <template v-if="downloadDialogRow.resolved_attachment_files && downloadDialogRow.resolved_attachment_files.length">
          <el-divider content-position="left">附件</el-divider>
          <div v-for="(f, idx) in downloadDialogRow.resolved_attachment_files" :key="f.id || idx" style="margin-bottom: 8px;">
            <el-button type="text" icon="el-icon-download" @click="openHref(f.file_path)">{{ f.file_name || ('附件' + (idx + 1)) }}</el-button>
          </div>
        </template>
        <p v-else-if="mergedAttachmentCount(downloadDialogRow) > 0" class="el-text--secondary" style="margin-top: 12px;">
          附件已关联但暂无文件明细，请稍后重试或联系管理员。
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="downloadDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import { mapGetters } from 'vuex'
import ApeUploader from '@/components/ApeUploader'
export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ApeDrawer,
    ApeUploader
  },
  data() {
    return {
      // 搜索条件
      searchCondition:{
        current_page: 1,
        page_size: 20,
        order_no: '',
        material_name: '',
        material_duration_name: '',
        quantity: '',
        total_duration: '',
        color_name: '',
        price: '',
        total_price: '',
        query: "",
        params: [],
      },
      loadingStaus: true,
      // 表格列表数据
      dataList:[],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      // 表单结构
      formData: {
        id:0
      },
      // 表单验证
      rules: {
        color_name: [{required: true,message:'输入颜色名称', trigger: 'blur' }],
        color_value: [{required: true,message:'输入颜色描述', trigger: 'blur' }],
      },
      // 抽屉数据
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '玩命加载中……',
        title: '权限绑定',
        width_height: '580px',
      },
      rolesList: [],
      userRoles: [],
      downloadDialogVisible: false,
      downloadDialogRow: null,
      craftDetailDialogVisible: false,
      craftDetailDialogRow: null,
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType'])
  },
  methods: {
    formatMoney(v) {
      const n = Number(v || 0)
      return `¥${n.toFixed(2)}`
    },
    formatDays(v) {
      const n = Number(v || 0)
      return `${n}天`
    },
    formatWeight(v) {
      const n = Number(v || 0)
      return `${n}g`
    },
    getTotalQuantity(rows) {
      return (rows || []).reduce((sum, row) => sum + Number(row.quantity || 0), 0)
    },
    getTotalSubPrice(rows) {
      return (rows || []).reduce((sum, row) => sum + Number(row.sub_total_price || 0), 0)
    },
    getTotalFollowCraftPrice(rows) {
      return (rows || []).reduce((sum, row) => sum + Number(row.follow_craft_price || 0), 0)
    },
    getMaxTotalDuration(rows) {
      return (rows || []).reduce((max, row) => Math.max(max, Number(row.total_duration || 0)), 0)
    },
    getTotalFollowCraftCount(rows) {
      return (rows || []).reduce((sum, row) => sum + this.getFollowCraftDetailList(row).length, 0)
    },
    publicAssetUrl(path) {
      if (path == null || path === '') return ''
      const s = String(path).replace(/\\/g, '/')
      if (/^https?:\/\//i.test(s)) return s
      if (s.startsWith('/assets/')) return s
      const marker = '/assetslib/'
      const i = s.indexOf(marker)
      if (i !== -1) {
        return '/assets/' + s.slice(i + marker.length).replace(/^\/+/, '')
      }
      return s
    },
    parseIdArray(raw) {
      if (raw == null) return []
      if (Array.isArray(raw)) return raw
      if (typeof raw === 'string') {
        try {
          const j = JSON.parse(raw)
          return Array.isArray(j) ? j : []
        } catch (e) {
          return []
        }
      }
      return []
    },
    mergedAttachmentIds(row) {
      const out = []
      const seen = new Set()
      const pushArr = (arr) => {
        if (!arr || !Array.isArray(arr)) return
        arr.forEach((id) => {
          const s = String(id || '').trim()
          if (!s || seen.has(s)) return
          seen.add(s)
          out.push(s)
        })
      }
      pushArr(this.parseIdArray(row.attachment_file_ids))
      if (row.FollowCraftDetail && row.FollowCraftDetail.length) {
        row.FollowCraftDetail.forEach((cd) => {
          pushArr(this.parseIdArray(cd.attachment_file_ids))
        })
      }
      return out
    },
    mergedAttachmentCount(row) {
      if (row.resolved_attachment_files && row.resolved_attachment_files.length) {
        return row.resolved_attachment_files.length
      }
      return this.mergedAttachmentIds(row).length
    },
    getFollowCraftDetailList(row) {
      if (!row || !Array.isArray(row.FollowCraftDetail)) return []
      return row.FollowCraftDetail
    },
    getFollowCraftName(detail) {
      if (!detail) return '后处理工艺'
      if (detail.FollowCraft && detail.FollowCraft.follow_craft_name) {
        return detail.FollowCraft.follow_craft_name
      }
      if (detail.follow_craft_name) return detail.follow_craft_name
      return '后处理工艺'
    },
    getFollowCraftId(detail) {
      if (!detail) return ''
      if (detail.follow_craft_id) return String(detail.follow_craft_id)
      if (detail.FollowCraft && detail.FollowCraft.id) return String(detail.FollowCraft.id)
      return ''
    },
    getFollowCraftAttachmentFiles(row, detail) {
      if (!row || !detail) return []
      const allFiles = Array.isArray(row.resolved_attachment_files) ? row.resolved_attachment_files : []
      if (!allFiles.length) return []
      const ids = new Set(this.parseIdArray(detail.attachment_file_ids).map((id) => String(id).trim()).filter(Boolean))
      if (!ids.size) return []
      return allFiles.filter((f) => ids.has(String(f.id || '').trim()))
    },
    goCraftDetailPage(row) {
      const details = this.getFollowCraftDetailList(row)
      if (!details.length) {
        this.$message.info('该订单项暂无后处理详情')
        return
      }
      this.$router.push(`/customer/order/${this.$route.params.id}/customer_order_item/${row.id}/customer_order_item_craft_detail`)
    },
    openHref(url) {
      const u = this.publicAssetUrl(url)
      if (u) window.open(u, '_blank')
    },
    openDownloadDialog(row) {
      this.downloadDialogRow = row
      this.downloadDialogVisible = true
    },
    // 搜索
    setSearchCondition() {
      this.searchCondition.query= "order_no=?"
      this.searchCondition.params = []
      this.searchCondition.params.push(this.$route.params.id)
      if (this.searchCondition.material_name != ''){
        this.searchCondition.query += ' and instr(material_name,?)'
        this.searchCondition.params.push(this.searchCondition.material_name)
      }
      if (this.searchCondition.material_duration_name !=''){
        this.searchCondition.query += ' and material_duration_name=?'
        this.searchCondition.params.push(this.searchCondition.material_duration_name)
      }
      if (this.searchCondition.quantity !=''){
        this.searchCondition.query += ' and quantity=?'
        this.searchCondition.params.push(this.searchCondition.quantity)
      }
      if (this.searchCondition.total_duration !=''){
        this.searchCondition.query += ' and total_duration=?'
        this.searchCondition.params.push(this.searchCondition.total_duration)
      }
      if (this.searchCondition.color_name !=''){
        this.searchCondition.query += ' and instr(color_name,?)'
        this.searchCondition.params.push(this.searchCondition.color_name)
      }
    },
    // 重置搜索条件
    resetSearch() {
      this.searchCondition.material_name = ''
      this.searchCondition.color_name = ''
      this.searchCondition.quantity = ''
      this.getList()
    },
    // 切换页码操作
    async switchPaging() {
      this.getList()
    },
    // 响应添加按钮
    async addButton() {
      this.formData = {}
      this.drawerData.visible = true
      this.drawerData.title = '添加订单项'
      this.drawerData.loading = false
    },
    // 响应编辑按钮
    async editButton(id) {
      this.drawerData.loading_text = '玩命加载中……'
      this.drawerData.visible = true
      this.drawerData.title = '编辑订单项(ID：'+id+')'
      let res = await this.$api.post('/service/customer_order/order_item_detail', {id: id})
      if (this.$apiSuccess(res)) {
        this.formData = res.data.result_detail
      } else {
        this.$message.error(res.message)
      }
      this.drawerData.loading = false
    },
    // 复制订单项
    async copyButton(row) {
      this.formData = JSON.parse(JSON.stringify(row))
      this.formData.id = undefined
      this.drawerData.visible = true
      this.drawerData.title = '复制订单项'
      this.drawerData.loading = false
      this.$message.success('已复制订单项，请修改后保存！')
    },
    // 查看工艺与后处理完整详情
    async viewCraftDetail(row) {
      if (!row.FollowCraftDetail || row.FollowCraftDetail.length === 0) {
        this.$message.info('该订单项暂无后处理详情');
        return;
      }
      this.craftDetailDialogRow = row
      this.craftDetailDialogVisible = true
    },
    // 批量操作
    async batchOperation() {
      this.$message.info('批量操作功能开发中...')
    },
    // 导出数据
    async exportData() {
      this.$message.info('数据导出功能开发中...')
    },
    // 处理抽屉关闭
    drawerClose() {
      this.initFormData()
      this.drawerData.visible = false
      this.drawerData.loading = true
      this.rolesList = []
    },
    // 处理抽屉确认
    async drawerConfirm() {
      // 调用组件的数据验证方法
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // form数据提交，请求接口
    async formSubmit() {
      this.drawerData.loading_text = '玩命提交中……'
      this.drawerData.loading = true
      let res
      this.formData.order_no = this.$route.params.id
      if(this.formData.id==undefined){
        res = await this.$api.post('/service/customer_order/order_item_create', this.formData)
      }else{
        res = await this.$api.post('/service/customer_order/order_item_update', this.formData)
      }
      
      if (this.$apiSuccess(res)) {
        this.$nextTick(() => {
          this.drawerData.visible = false
        })
        this.$nextTick(async () => {
          this.getList()
        })
        this.$nextTick(() => {
          this.$message.success('保存成功!')
        })
      } else {
        this.$message.error(res.message)
      }
      this.initFormData()
    },
    // row数据提交，请求接口
    async rowSubmit(row) {
      this.drawerData.loading_text = '玩命提交中……'
      this.drawerData.loading = true
      if(row.craft_status=='0'){
        row.craft_status='1'
      }else{
        row.craft_status='0'
      }
      let id = await this.$api.modifyCustomerOrderItem(row)
      this.$nextTick(() => {
        this.drawerData.visible = false
      })
      this.$nextTick(async () => {
        if (id) {
          this.getList()
        }
      })
      this.$nextTick(() => {
        this.$message.success('保存成功!')
      })
      this.initFormData()
    },
    // 相应删除按钮
    async deleteButton(id) {
      let res = await this.$api.post('/service/customer_order/order_item_delete', {id: id})
      if (this.$apiSuccess(res)) {
        this.$message.success('删除成功!')
        this.$nextTick(async () => {
          this.getList()
        })
      } else {
        this.$message.error(res.message)
      }
    },
    // 初始化数据
    initFormData() {
      // 初始化form表单
      this.$nextTick(() => {
        this.formData = {id:0}
        this.$refs['dataForm'] && this.$refs['dataForm'].resetFields()
      })
    },
    // 初始化数据列表
    async getList() {
      this.loadingStaus=true
      this.setSearchCondition()
      let res = await this.$api.post('/service/customer_order/order_item_list',this.searchCondition)
      if (this.$apiSuccess(res)){
        this.dataList=res.data.list
        this.pagingData.total = res.data.page.total
        this.offset = (this.searchCondition.current_page - 1) * this.searchCondition.page_size
      }else{
        this.$message.error(res.message)
        this.dataList=[]
        this.loadingStaus=false
        return
      }
      this.loadingStaus=false
    },
    // 格式化日期时间
    formatDateTime(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    // 显示材料描述
    showMaterialDesc(material) {
      let content = material.material_desc || '暂无描述';
      
      // 如果有优势和劣势信息，添加到描述中
      if (material.material_advantage) {
        content += '\n\n' + material.material_advantage;
      }
      
      // 如果有自定义属性，也添加到描述中
      if (material.material_customize && material.material_customize.length > 0) {
        content += '\n\n材料属性：';
        material.material_customize.forEach(item => {
          content += `\n${item.title}：\n${item.content}`;
        });
      }
      
      // 添加材料标签信息
      if (material.material_label) {
        content += '\n\n材料标签：' + material.material_label;
      }
      
      // 添加推荐等级
      if (material.material_recommend) {
        content += '\n\n推荐等级：' + (material.material_recommend == '1' ? '推荐' : '普通');
      }
      
      this.$alert(content, '材料详细信息', {
        confirmButtonText: '确定',
        customClass: 'material-desc-dialog',
        dangerouslyUseHTMLString: false,
        showClose: true,
        closeOnClickModal: true,
        closeOnPressEscape: true,
        showCancelButton: false,
        beforeClose: (action, instance, done) => {
          done();
        }
      });
    },
    
    // 查看附件信息（与下载弹窗一致）
    viewAttachments(row) {
      this.openDownloadDialog(row);
    }
  },
  mounted() {
    this.getList()
  },
}
</script>

<style lang="stylus" scoped>
// 页面标题区域样式
.page-title-section
  background linear-gradient(135deg, #667eea 0%, #764ba2 100%)
  border-radius 12px
  padding 24px
  margin-bottom 20px
  color white
  
  .title-content
    .page-title
      margin 0 0 8px 0
      font-size 24px
      font-weight 600
      display flex
      align-items center
      
      i
        margin-right 12px
        font-size 28px
    
    .page-subtitle
      margin 0
      opacity 0.9
      font-size 14px

// 操作面板样式
.action-card
  background white
  border-radius 12px
  padding 16px 20px
  margin-bottom 20px
  box-shadow 0 2px 12px rgba(0, 0, 0, 0.08)
  
  .action-buttons
    display flex
    gap 8px

// 搜索卡片样式
.search-card
  background white
  border-radius 12px
  padding 20px
  margin-bottom 20px
  box-shadow 0 2px 12px rgba(0, 0, 0, 0.08)
  
  .search-header
    display flex
    align-items center
    margin-bottom 16px
    font-weight 600
    color #303133
    
    i
      margin-right 8px
      color #409eff
  
  .search-content
    .search-form
      margin 0
      
      /deep/ .el-form-item
        margin-bottom 0
        margin-right 20px

// 表格卡片样式
.table-card
  background white
  border-radius 12px
  padding 20px
  box-shadow 0 2px 12px rgba(0, 0, 0, 0.08)

  .order-overview-card
    margin-bottom 16px
    padding 12px 14px
    border 1px solid #ebeef5
    border-radius 10px
    background #fafcff

    .overview-title
      display flex
      align-items center
      gap 8px
      font-weight 600
      color #303133
      margin-bottom 8px

    .overview-content
      display flex
      flex-wrap wrap
      gap 8px
  
  .table-header
    display flex
    justify-content space-between
    align-items center
    margin-bottom 20px
    padding-bottom 12px
    border-bottom 2px solid #f0f2f5
    
    .header-left
      .table-title
        color #1f2937
        font-size 18px
        font-weight 600
        margin 0
        display flex
        align-items center
        gap 8px
        
        i
          color #409eff
          
    .header-right
      .data-count
        color #6b7280
        font-size 14px
  
  /deep/ .el-table
    border-radius 8px
    overflow hidden
    
    th
      background #f8f9fa
      color #303133
      font-weight 600
      border-bottom 2px solid #e4e7ed
    
    td
      border-bottom 1px solid #f0f0f0
      padding 12px 8px
    
    tr:hover
      background #f5f7fa

// 序号样式
.sequence-number
  display inline-flex
  align-items center
  justify-content center
  width 24px
  height 24px
  background #409eff
  color white
  border-radius 50%
  font-size 12px
  font-weight 600

// 汇总信息显示样式
.material-summary, .file-summary, .post-processing-summary, .attachment-summary
  .summary-header
    display flex
    justify-content space-between
    align-items center
    margin-bottom 12px
    padding-bottom 8px
    border-bottom 1px solid #f0f0f0
    
    .material-title, .file-title, .craft-title, .attachment-title
      display flex
      align-items center
      gap 8px
      
      i
        color #409eff
        font-size 16px
      
      .material-name, .file-name, .craft-name, .attachment-name
        font-weight 600
        color #303133
        font-size 14px
    
    .material-image
      img
        width 40px
        height 40px
        border-radius 6px
        border 2px solid #e4e7ed
        object-fit cover
  
  .summary-content
    .summary-row
      display flex
      align-items center
      margin-bottom 6px
      font-size 12px
      
      i
        color #409eff
        margin-right 6px
        font-size 14px
        width 14px
      
      .summary-label
        color #909399
        margin-right 4px
        font-weight 500
        min-width 60px
      
      .summary-value
        color #303133
        font-weight 500
        line-height 1.4
        
        &.price
          color #f56c6c
          font-weight 600
          
        &.total-price
          color #e6a23c
          font-weight 600
  
  .material-tags
    margin-top 8px
    padding-top 8px
    border-top 1px solid #f0f0f0
    
    .tags-title
      font-size 12px
      color #909399
      margin-bottom 4px
      font-weight 500
    
    .tags-container
      display flex
      flex-wrap wrap
      gap 4px
    
    .attachment-list
      display flex
      flex-wrap wrap
      gap 2px
      margin-top 2px
    
    .craft-stats
      display flex
      flex-wrap wrap
      gap 2px
      margin-top 2px

.order-item-basic
  .info-row
    display flex
    align-items center
    margin-bottom 6px
    font-size 12px

    i
      color #409eff
      margin-right 6px
      font-size 14px
      width 14px

    .info-label
      color #909399
      margin-right 4px
      font-weight 500
      min-width 56px

    .info-value
      color #303133
      font-weight 500
      word-break break-all

// 工艺信息样式
.craft-info
  .info-row
    .el-button--text
      color #409eff
      padding 0
      font-size 12px
      
      &:hover
        color #66b1ff

// 材料属性样式
.material-properties
  .info-row
    .tags-container
      display flex
      flex-wrap wrap
      gap 4px
      margin-top 4px
    
    .el-button--text
      color #409eff
      padding 0
      font-size 12px
      
      &:hover
        color #66b1ff

// 行总价显示样式
.total-price-display
  display flex
  flex-direction column
  align-items center
  gap 6px
  
  .price-breakdown
    display flex
    flex-direction column
    align-items center
    gap 4px
    
    .price-item
      display flex
      align-items center
      gap 6px
      font-size 12px
      
      .price-label
        color #909399
        font-weight 500
        min-width 60px
      
      .price-value
        color #f56c6c
        font-weight 600

    .duration-item
      display flex
      align-items center
      gap 6px
      font-size 12px

      .duration-label
        color #909399
        font-weight 500
        min-width 60px
    
    .price-total
      margin-top 6px
      padding-top 6px
      border-top 1px solid #f0f0f0

// 行总工期显示样式
.total-duration-display
  display flex
  flex-direction column
  align-items center
  gap 6px
  
  .duration-breakdown
    display flex
    flex-direction column
    align-items center
    gap 4px
    
    .duration-item
      display flex
      align-items center
      gap 6px
      font-size 12px
      
      .duration-label
        color #909399
        font-weight 500
        min-width 60px
    
    .duration-total
      margin-top 6px
      padding-top 6px
      border-top 1px solid #f0f0f0

// 备注显示样式
.remark-display
  display flex
  justify-content center
  
  .no-remark
    color #c0c4cc
    font-size 12px
    font-style italic

// 时间显示样式
.time-display
  display flex
  justify-content center

// 文件链接样式
.file-link
  color #409eff
  text-decoration none
  font-size 12px
  display flex
  align-items center
  
  i
    margin-right 4px
  
  &:hover
    color #66b1ff
    text-decoration underline

// 数据展示区域
.quantity-display, .duration-display, .color-display, .price-display, .total-price-display, .quantity-duration-display
  display flex
  justify-content center
  
  .el-tag
    border-radius 8px
    font-weight 600
    
    i
      margin-right 4px

// 操作按钮样式
.action-buttons
  display flex
  gap 6px
  justify-content center
  
  .el-button.is-circle
    padding 6px
    
    &:hover
      transform translateY(-2px)
      transition all 0.3s ease

// 动画效果
@keyframes pulse
  0%
    opacity 1
  50%
    opacity 0.5
  100%
    opacity 1

// 响应式设计
@media (max-width: 768px)
  .page-title-section
    padding 16px
    
    .page-title
      font-size 20px
  
  .search-content
    .search-form
      /deep/ .el-form-item
        margin-right 10px
        margin-bottom 10px
  
  .table-header
    flex-direction column
    align-items flex-start
    gap 10px

// 全局样式优化
/deep/ .el-button
  border-radius 6px
  transition all 0.3s ease
  
  &:hover
    transform translateY(-1px)
    box-shadow 0 4px 12px rgba(64, 158, 255, 0.3)

/deep/ .el-input
  .el-input__inner
    border-radius 6px
    transition all 0.3s ease
    
    &:focus
      box-shadow 0 0 8px rgba(64, 158, 255, 0.2)

/deep/ .el-tag
  border-radius 6px
  
  &.el-tag--large
    padding 8px 12px
    font-size 13px
  
  &.el-tag--medium
    padding 6px 10px
    font-size 12px
  
  &.el-tag--mini
    padding 2px 6px
    font-size 11px

// 搜索表单优化
.search-form
  /deep/ .el-form-item__label
    color #374151
    font-weight 500
    
  /deep/ .el-input__inner
    border 1px solid #d1d5db
    
    &:focus
      border-color #409eff
      box-shadow 0 0 0 2px rgba(64, 158, 255, 0.1)

// 材料描述对话框样式
/deep/ .material-desc-dialog
  .el-message-box__content
    max-height 400px
    overflow-y auto
    
  .el-message-box__message
    white-space pre-line
    line-height 1.6

// 附件对话框样式
/deep/ .attachment-dialog
  .el-message-box__content
    max-height 400px
    overflow-y auto
    
  .el-message-box__message
    white-space pre-line
    line-height 1.6

// 工艺详情对话框样式
/deep/ .craft-detail-dialog
  .el-message-box__content
    max-height 400px
    overflow-y auto
    
  .el-message-box__message
    white-space pre-line
    line-height 1.6

.order-item-detail-dialog
  /deep/ .el-dialog__body
    padding-top 10px
  .craft-detail-content
    max-height 70vh
    overflow-y auto
    padding-right 4px
  .detail-block
    border 1px solid #ebeef5
    border-radius 8px
    padding 10px 12px
    margin-bottom 10px
    background #fff
  .block-title
    font-weight 600
    color #303133
    margin-bottom 8px
    display flex
    align-items center
    gap 6px
  .kv-line
    font-size 12px
    line-height 1.8
    color #303133
    span
      color #909399

// 新增样式优化
.material-summary, .file-summary, .post-processing-summary, .attachment-summary
  .summary-header
    .material-title, .file-title, .craft-title, .attachment-title
      .el-tag
        margin-left 8px
        
  .summary-content
    .summary-row
      .el-button--text
        color #409eff
        padding 0
        font-size 12px
        
        &:hover
          color #66b1ff
          
      .file-link
        color #409eff
        text-decoration none
        font-size 12px
        display flex
        align-items center
        
        i
          margin-right 4px
        
        &:hover
          color #66b1ff
          text-decoration underline

// 响应式优化
@media (max-width: 1200px)
  .material-summary, .file-summary, .post-processing-summary, .attachment-summary
    .summary-header
      flex-direction column
      align-items flex-start
      gap 8px
      
    .summary-content
      .summary-row
        flex-wrap wrap
        gap 4px
</style>
